import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";

const initialState = {
  user: null,
  topbarTitle: null,
}

const openNotification = (config) => {
  notification.open({
    message: config.message,
    description: config.description,
    placement: config.placement,
    duration: config.duration,
  });
};

export const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {
    addUser(state, action) {
      state.user = action.payload
    },
    removeUser(state, action) {
      state.user = null
    },
    addTopbarTitle(state, action) {
      state.topbarTitle = action.payload
    },
    resetState(state, action) {
      state = initialState
    },
    notify(state, action) {
      openNotification(action.payload)
    }
  }
})